module.exports = __webpack_public_path__ + "static/media/sombra-capa-interna.6f8002ce.svg";